/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfilePrivacyPreferenceRequest
 */
export interface ProfilePrivacyPreferenceRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ProfilePrivacyPreferenceRequest
     */
    profileVisible: boolean;
}

/**
 * Check if a given object implements the ProfilePrivacyPreferenceRequest interface.
 */
export function instanceOfProfilePrivacyPreferenceRequest(value: object): value is ProfilePrivacyPreferenceRequest {
    if (!('profileVisible' in value) || value['profileVisible'] === undefined) return false;
    return true;
}

export function ProfilePrivacyPreferenceRequestFromJSON(json: any): ProfilePrivacyPreferenceRequest {
    return ProfilePrivacyPreferenceRequestFromJSONTyped(json, false);
}

export function ProfilePrivacyPreferenceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfilePrivacyPreferenceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'profileVisible': json['profileVisible'],
    };
}

export function ProfilePrivacyPreferenceRequestToJSON(value?: ProfilePrivacyPreferenceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'profileVisible': value['profileVisible'],
    };
}

